import React from "react";
import { ManualAccountForm } from "../../../components/ManualAccountFormPreview/ManualAccountFormPreview";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { SetupLayout } from "../../../components/SetupFlow/SetupFlowLayout";

export const AddStandardPayoutMethodManual: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  return (
    <SetupLayout title="Enter your account info" onBack={onBack}>
      <ManualAccountForm
        onSubmit={onNext}
        submitButtonText="Continue"
        submitButtonName="continue"
      />
    </SetupLayout>
  );
};
